import { useEffect, useState } from "react";
import { Header } from "../../elements/header/Header";
import VideoPreviewHorizontalPlaceholder from "../../elements/video-preview/placeholder-horizontal";
import './search-styles.css';
import { useParams } from "react-router-dom";
import { requestJSONBy } from "../../functions/api/fetcher";

export default function Search() {
  const [searchData, setSearchData] = useState(null);
  let params = useParams()

  useEffect(() => {
    if (!params.q) {
      setSearchData([]);
      return;
    }
    requestJSONBy('/api/v1/find_video.php', (data) => {
      setSearchData(data.videos);
    }, () => {
      setSearchData([]);
    })
  }, [params.q])

  return (
    <>
      <Header />
      {searchData === null? <SearchResultPlaceholders /> :""}
      {searchData !== null && searchData.length === 0 ? <NoSearchResults /> :""}
      {searchData !== null && searchData.length > 0 ? <p>No code to display that</p>: ""}
    </>
  );
}

function SearchResultPlaceholders() {
  return <div className="search-videos-list">
    {[...Array(30)].map((e, i) => <VideoPreviewHorizontalPlaceholder  key={i} />)  /* Placeholder */}
  </div>
}

function NoSearchResults() {
  return <div className="search-no-videos-found">
    <h1>Не нашли</h1>
    <h3>А ты точно хорошо написал запрос?</h3>
  </div>
}